<template>
	<vUpload
		ref="Upload"
		:xhr="xhr"
		:format="format"
		:accept="accept"
		progress
		draggable
		multiple
		style="width:100%"
		@on-remove="handleAbort"
	>
		<div style="padding: 30px 10px;text-align:center;">
			<vIcon type="ios-cloud-upload" size="36" style="color: #3399ff"></vIcon>
			<p>{{$t('global.common.select_attachment')}}</p>
		</div>
		<footer slot="footer" class="padding-top-10 text-right" slot-scope="{stratUpload}">
			<div class="text-center margin-bottom-10 color-error">
				<div v-if="warningtitle" v-html="warningtitle"></div>
				<template v-else>
					<slot name="tip">{{tip}}</slot>
				</template>
			</div>
			<vButton
				v-if="download"
				theme="info"
				class="margin-right-20"
				@click.stop="download"
				icon="cloud-download"
			>{{$t('global.common.download_template')}}</vButton>
			<vButton
				class="margin-right-20"
				theme="primary"
				@click.stop="stratUpload"
				icon="cloud-upload"
			>{{$t('global.upload.import')}}</vButton>
			<vButton @click.stop="handleAbort()">{{$t('global.common.close')}}</vButton>
		</footer>
	</vUpload>
</template>
<script>
import HttpService from '../../service/baseHttp'
import axios from 'axios'
export default {
	inheritAttrs: false,
	props: ['download', 'refresh', 'action', 'name', 'data', 'format', 'accept', 'ajaxRequest', 'warningtitle','tip'],
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		handleAbort(fileInfo) {
			if (!fileInfo) {
				Object.keys(this.cancelXHRs || {}).forEach(key => {
					if (this.cancelXHRs[key]) this.cancelXHRs[key].cancel();
				});
				this.cancelXHRs = {};
				this.$emit('on-cancel');
				this.$emit('on-close');
			} else {
				const key = fileInfo.name + fileInfo.size;
				if (this.cancelXHRs[key]) this.cancelXHRs[key].cancel();
			}

		},
		xhr(params = {}) {
			const { file, onProgress, onSuccess, onError, fileInfo } = params;
			const formData = new FormData();
			const cancelXHR = axios.CancelToken.source();
			if (!this.cancelXHRs) this.cancelXHRs = {};
			this.cancelXHRs[fileInfo.name + fileInfo.size] = cancelXHR;
			Object.entries((this.data || {})).forEach(([key, val]) => {
				formData.append(key, val);
			})
			formData.append(this.name, file);
			formData.append('contextId', global.SYSID);
			const args = [this.action, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
					"Authorization": 'Bearer ' + global.AUTH_TOKEN,
				},
				withCredentials: true,
				transformRequest(data) {
					return data
				},
				onUploadProgress: function (progressEvent) {
					// console.log(progressEvent, 'progressEvent')
					onProgress(progressEvent)
				},
				cancelToken: cancelXHR.token
			}];
			const ajaxRequest = (!this.action && typeof this.ajaxRequest === 'function') ? this.ajaxRequest(...args.slice(1)) : HttpService.post(...args);
			return ajaxRequest.then(res => {
				if (res.code != 200 && res.status != 200) {
					return Promise.reject(res);
				} else {
                    this.$VMessage.success(res.message)
					onSuccess(res);
					this.$emit('on-success', res);
					setTimeout(() => {
						this.$emit('on-update');
					}, 2000);
				}
			}).catch(error => {
				onError(error);
                // this.$VMessage.error(error.message);
                this.errorMessage(error.message)
				this.$emit('on-error', error);
			})
		},
	},
};
</script>


